import {
  allSustainabilityMatterIdsHash,
  SustainabilityMatterId,
} from '@upright/common/model/input/materiality-assessment/types-matters';
import { parse, ParsedUrlQuery, stringify } from 'querystring';

export interface MaterialitySelectionState {
  matter?: SustainabilityMatterId;
  // TODO: other fields
}

function serializeSelectionState(state: MaterialitySelectionState) {
  return stringify({
    matter: state.matter,
  });
}

function unserializeSelectionState(value: string | undefined): MaterialitySelectionState {
  if (!value) {
    return {};
  }
  const parsed: ParsedUrlQuery = parse(value);

  function parseMatter(val: string | undefined) {
    if (!val) {
      return undefined;
    }
    if (allSustainabilityMatterIdsHash[val]) {
      return val as SustainabilityMatterId;
    }
    return undefined;
  }

  return {
    matter: parseMatter(parsed.matter as string),
  };
}

function isImpactHighlighted() {
  return false;
}

export const materialityLensSelectionState = {
  serializeSelectionState,
  // TODO Should this be removed?
  unserializeSelectionState,
  isImpactHighlighted,
};
